import { createSlice } from "@reduxjs/toolkit";
import { fetchMoreSpaces } from "../Thunks/moreSpaceThunks";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const moreSpacesSlice = createSlice({
  name: "moreSpaces",
  initialState,
  reducers: {
    clearMoreSpaces: (state) => {
      state.list = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchMoreSpaces, {
      onFulfilled: (state, action) => {
        state.list = action.payload;
      },
    });
  },
});

export const { clearMoreSpaces } = moreSpacesSlice.actions;

export default moreSpacesSlice.reducer;
